
async function logUserAction(userid, action){
    if (!userid || !action) return;
    const KC_SERVICE = process.env.REACT_APP_KC_SERVICE || 'https://kc-service-eight.vercel.app'; // https://kc-service-eight.vercel.app // http://localhost:3000

    // Call your backend service API in this function
    const response = await fetch(KC_SERVICE + '/log_UserAction', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        UserID: userid, 
        Action: action
      })
    });

    // const result = await response.json();
    if (response.ok) {

    }
    else 
    {
      console.log('Failed to log user action:');
    }
}

export default logUserAction;